import { render, staticRenderFns } from "./LayoutsUseOfBarFourSection.vue?vue&type=template&id=45bbe414"
import script from "./LayoutsUseOfBarFourSection.vue?vue&type=script&lang=ts"
export * from "./LayoutsUseOfBarFourSection.vue?vue&type=script&lang=ts"
import style0 from "./LayoutsUseOfBarFourSection.vue?vue&type=style&index=0&id=45bbe414&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports